/**
 * A GWI insight comes back as a loosely-typed record `{ id, text }`. Render the
 * human-readable text, falling back to its entries (minus id) if absent.
 */
export function formatInsight(insight: Record<string, unknown>): string {
  if (typeof insight.text === 'string') {
    return insight.text;
  }
  return Object.entries(insight)
    .filter(([key]) => key !== 'id')
    .map(([key, value]) => `${key}: ${String(value)}`)
    .join(' · ');
}
